/** Aggregated counts shown on the repository overview. Shared by the page
 *  (data loader) and the RepositoryOverview presentational component. */
export interface OverviewStats {
  scans: { total: number; pending: number; running: number; succeeded: number; failed: number };
  findings: {
    total: number;
    bySeverity: { critical: number; high: number; medium: number; low: number };
    byStatus: { open: number; needsReview: number; resolved: number; ignored: number; falsePositive: number };
  };
  fixes: { total: number; pending: number; running: number; completed: number; failed: number };
}

export const initialStats: OverviewStats = {
  scans: { total: 0, pending: 0, running: 0, succeeded: 0, failed: 0 },
  findings: {
    total: 0,
    bySeverity: { critical: 0, high: 0, medium: 0, low: 0 },
    byStatus: { open: 0, needsReview: 0, resolved: 0, ignored: 0, falsePositive: 0 },
  },
  fixes: { total: 0, pending: 0, running: 0, completed: 0, failed: 0 },
};
